import { createSelector } from 'reselect';
import { CheckoutSettingsValues, QuoteSettingsValues, Settings } from '../../models/Settings';
import { RootState } from '../hooks';
import { settingsApi } from '../api/settingsApi';

export const selectSettings = (state: RootState): Settings[] =>
  settingsApi.endpoints.getSettingsData.select(undefined)(state).data ?? [];

export const selectSettingsValues = createSelector(
  [selectSettings, (_, settingsName: string) => settingsName, (_, __, page: string) => page],
  (settings, settingsName, page) =>
    settings.find((setting) => setting.settingsName === settingsName && setting.page === page)
      ?.values ?? {},
);

export const selectQuoteSettings = createSelector(
  selectSettings,
  (settings) =>
    settings.find((setting) => setting.settingsName === 'quoteSettings')
      ?.values as QuoteSettingsValues,
);

export const selectCheckoutSettings = createSelector(
  selectSettings,
  (settings) =>
    settings.find(
      (setting) => setting.settingsName === 'newCheckout' && setting.page === 'newCheckout',
    )?.values as CheckoutSettingsValues,
);

export const selectQuotesEnabled = createSelector(
  selectQuoteSettings,
  (quoteSettings) => quoteSettings?.isEnabled ?? false,
);

export const selectNewCheckoutEnabled = createSelector(
  selectCheckoutSettings,
  (settings) => settings?.enabled ?? false,
);
